<template>
  <div class="tools">
    <ul>
      <!--<li v-if="member && canManageEntries">
        <b-btn
                class="add-entry edit-timesheets-btn"
                @click="editTimesheets"
        >
          <i class="atto atto-add-more" />
          Edit Timesheets
        </b-btn>
      </li>-->
      <li v-if="isConnectedToXero && (user.is_owner || user.role_id === 1)">
        <b-btn class="export-timesheet" @click="exportTimesheetsModal">
          <i class="atto atto-export" />
          {{ label.get("export_to_xero") }}
        </b-btn>
      </li>
      <!--      <li v-if="member">
        <b-btn
            class="filter-timesheet"
        >
          <i class="atto atto-filter" />
          Filter
        </b-btn>
      </li>-->
      <li v-if="member && showDownloadLicense">
        <b-btn
          class="download-license"
          :disabled="downloadBtnDisabled"
          @click="downloadMemberLicense"
        >
          <i class="atto atto-download" />
          {{ label.get("Download License") }}
        </b-btn>
      </li>
      <li v-if="member && canManageEntries">
        <b-btn class="add-entry" @click="createManualEntry">
          <i class="atto atto-add-more" />
          {{ label.get("add_new_entry") }}
        </b-btn>
      </li>

      <li v-if="download">
        <b-dropdown right class="download-dropdown">
          <template slot="button-content">
            <i class="atto atto-download" />
            <span class="download">{{ label.get("download") }}</span>
          </template>
          <b-dropdown-item @click="downloadNewReport">
            {{ label.get("timesheet_report") }}
          </b-dropdown-item>
          <b-dropdown-item @click="downloadJobCodeReport">
            {{ label.get("job_code_report") }}
          </b-dropdown-item>
        </b-dropdown>
      </li>
    </ul>
  </div>
</template>

<script>
import ReportService from "../shared/services/ReportService";
import UserService from "../../settings/services/UserService";
import AuthService from "../../../shared/services/AuthService";
export default {
  name: "TimesheetToolsComponent",
  props: {
    member: {
      type: Object,
      default: null,
    },
    canManageEntries: {
      type: Boolean,
      default: false,
    },
    download: {
      type: Boolean,
      default: false,
    },
    date: {
      type: String,
      default: undefined,
    },
    showDownloadLicense: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      downloadBtnDisabled: false,
      user: this.$store.state.user,
    };
  },
  computed: {
    isConnectedToXero() {
      return this.$store.state.isConnectedToXero;
    },
  },
  methods: {
    createManualEntry() {
      this.$root.$emit("showCreateEntry", {
        member: this.member,
        selectedDate: this.date,
      });
    },
    editTimesheets() {
      this.$root.$emit("editTimesheets");
    },
    downloadMemberLicense() {
      const memberId = this.member !== null ? this.member.id : "";
      this.downloadBtnDisabled = true;
      this.$store.commit("showLoading");
      UserService.getDownloadMemberLicense(memberId)
        .then((response) => {
          let filename = "";
          const disposition = response.headers["content-disposition"];
          if (disposition && disposition.indexOf("attachment") !== -1) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches !== null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(response.data, filename);
          } else {
            const a = document.createElement("a");
            a.href = window.URL.createObjectURL(response.data);

            a.download = filename;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
          }
          this.downloadBtnDisabled = false;
          this.$store.commit("hideLoading");
        })
        .catch(() => {
          this.downloadBtnDisabled = false;
          this.$store.commit("hideLoading");
        });
    },

    downloadNewReport() {
      let deleted = this.showArchivedMembers;
      const memberId = this.member !== null ? this.member.id : "";
      if (this.$route.name === "ArchivedMemberTimesheets") {
        deleted = true;
      }
      if (this.member && this.member.deleted) {
        deleted = true;
      }

      this.downloadBtnDisabled = true;
      this.$store.commit("showLoading");
      ReportService.getDownloadReport(
        memberId,
        this.$store.state.period.from,
        this.$store.state.period.to,
        "",
        deleted
      )
        .then((response) => {
          let filename = "";
          const disposition = response.headers["content-disposition"];
          if (disposition && disposition.indexOf("attachment") !== -1) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches !== null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(response.data, filename);
          } else {
            const a = document.createElement("a");
            a.href = window.URL.createObjectURL(response.data);

            a.download = filename;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
          }
          this.downloadBtnDisabled = false;
          this.$store.commit("hideLoading");
        })
        .catch(() => {
          this.downloadBtnDisabled = false;
          this.$store.commit("hideLoading");
        });
    },

    downloadJobCodeReport() {
      let deleted = this.showArchivedMembers;
      const memberId = this.member !== null ? this.member.id : "";
      if (this.$route.name === "ArchivedMemberTimesheets") {
        deleted = true;
      }
      if (this.member && this.member.deleted) {
        deleted = true;
      }

      this.downloadBtnDisabled = true;
      this.$store.commit("showLoading");
      ReportService.getDownloadJobCodeReport(
        memberId,
        this.$store.state.period.from,
        this.$store.state.period.to,
        deleted
      )
        .then((response) => {
          let filename = "";
          const disposition = response.headers["content-disposition"];
          if (disposition && disposition.indexOf("attachment") !== -1) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            if (matches !== null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(response.data, filename);
          } else {
            const a = document.createElement("a");
            a.href = window.URL.createObjectURL(response.data);

            a.download = filename;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
          }
          this.downloadBtnDisabled = false;
          this.$store.commit("hideLoading");
        })
        .catch(() => {
          this.downloadBtnDisabled = false;
          this.$store.commit("hideLoading");
        });
    },
    exportTimesheetsModal() {
      this.$root.$emit("showXeroTimesheetsExport");
    },
  },
};
</script>
<style lang="scss">
.tools {
  display: flex;
  height: auto;
  max-width: 960px;
  padding: 0 8px;
  justify-content: flex-end;
  align-self: center;

  ul {
    display: inline-flex;
    min-height: 30px;
    height: 30px;
    align-items: center;

    li {
      margin-left: 25px;

      button,
      a {
        font-size: 0.8125rem;
        line-height: 0.9375rem;
        font-family: $roboto-font;
        font-weight: 500;
        color: $atto-font-color;
        display: flex;
        align-items: center;
        padding: 0;
        border: 0;
        background-color: transparent;
        cursor: pointer;
        @include base-transition(ease all 0.1s);

        i {
          width: 24px;
          height: 24px;
          font-size: 0.765rem;
          margin-right: 4px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          @include base-transition(ease all 0.1s);
        }

        &:not(:disabled):not(.disabled):active,
        &:focus,
        &:active:focus,
        &:active {
          outline: 0 !important;
          border: 0 !important;
          box-shadow: none !important;
          background-color: transparent;
          color: #262626;
        }

        &:hover {
          background-color: transparent;
          color: $atto-font-color;
          i {
            background-color: #efefef;
            border-radius: 100%;
          }
        }

        &.disabled,
        &:disabled {
          background-color: transparent;
          color: $atto-font-color;
        }
      }

      .download-dropdown {
        .dropdown-toggle::after {
          display: none;
        }

        ul {
          display: none;
        }
        &.show {
          ul {
            display: block;
            border-radius: 0;
            border: 0;
            z-index: 9999999;
            background-color: #fff;
            box-shadow: 0 4px 10px 0 rgba(38, 38, 38, 0.15);
            width: auto;
            padding: 8px 0;
            height: auto;

            li {
              margin: 0;
              a {
                display: inline-flex;
                padding: 12px;
                font-size: 1rem;
                line-height: 1.5rem;
                font-family: "Roboto", sans-serif;
                color: #262626;
                font-weight: 400;
                width: 100%;
                align-items: center;
                justify-content: center;

                &:hover {
                  background-color: #f7f7f7;
                }
              }
              &:first-child {
                margin-right: 0;
              }
              &:last-child {
                margin-left: 0;
              }
            }
          }
        }
      }
      .btn-secondary:not(:disabled):not(.disabled):active,
      .btn-secondary:not(:disabled):not(.disabled).active,
      .show > .btn-secondary.dropdown-toggle {
        background-color: transparent !important;
        border: none;
        color: #262626;
      }
      .export-timesheet {
        border-right: 1px solid #e3e3e3;
        border-radius: 0;
        padding-right: 27px;
      }
    }
  }
}
</style>
